<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll('iso2_code')"
    @check-none="checkNone('iso2_code')"
    @set-selected-row="setSelectedRow($event, 'iso2_code')"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as COUNTRY_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'CountryTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'iso2_code',
          label: this.$t('ISO2 Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'iso2_code'
        },
        {
          key: 'iso3_code',
          label: this.$t('ISO3 Code'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'iso3_code'
        },
        {
          key: 'is_cee',
          label: this.$t('CEE'),
          type: 'boolean',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'is_cee'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          type: 'text',
          thClass: 'text-nowrap',
          tdClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'printable_name',
          label: this.$t('Printable Name'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'printable_name'
        },
        {
          key: 'numcode',
          label: this.$t('ISO numeric'),
          tdClass: 'text-nowrap text-right',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'numcode'
        },
        {
          key: 'continent',
          label: this.$t('Continent'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'continent_name'
        },
        {
          key: 'admin_area',
          label: this.$t('Administrative area'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'admin_area_name'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'iso2_code', 'iso3_code', 'is_cee', 'name', 'printable_name', 'numcode', 'continent', 'admin_area'],
      fieldName: 'iso2_code'
    }
  },
  computed: {
    ...mapGetters({
      selectAll: COUNTRY_TYPES.GENERIC.l10n.country.LIST.GETTERS.selectAll,
      selectedList: COUNTRY_TYPES.GENERIC.l10n.country.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('l10n_country_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: COUNTRY_TYPES.GENERIC.l10n.country.LIST.MUTATIONS.setList,
      setSelectedList:
        COUNTRY_TYPES.GENERIC.l10n.country.LIST.MUTATIONS.setSelectedList,
      setSelectAll: COUNTRY_TYPES.GENERIC.l10n.country.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...COUNTRY_TYPES.GENERIC.l10n.country.LIST.ACTIONS
    })
  }
}
</script>
